<template>
    <div>
        <BodycheckTags />
    </div>
</template>

<script>
import BodycheckTags from "./bodycheckTagsView.vue";
export default {
    components: {
        BodycheckTags,
    },
    data() {
        return{
            
        }
    },
    created(){
        
    }
};
</script>
